import { createSlice } from '@reduxjs/toolkit'
import { Farm } from '../../graphql/api/types'
import { CreateClientPayload } from '../../pages/ClientHierarchy/types/Customer'

type ClientState = {
  onDraft: CreateClientPayload | null
  farm: Farm | null
}

type ClientSlicer = {
  readonly undraft: (state: ClientState) => void
  readonly clearFarmState: (state: ClientState) => void
}

const initialState: ClientState = {
  onDraft: null,
  farm: null,
}

export const clientsSlice = createSlice<ClientState, ClientSlicer>({
  name: 'clients',
  initialState,
  reducers: {
    undraft: (state) => {
      state.onDraft = null
    },
    clearFarmState: (state) => {
      state.farm = null
    },
  },
})

export const { undraft, clearFarmState } = clientsSlice.actions
